export const ACTION_MODES = {
  navigate: "navigate",
  popupTable: "popup-table",
};
